import { render, staticRenderFns } from "./editPay.vue?vue&type=template&id=8f159b06&scoped=true&"
import script from "./editPay.vue?vue&type=script&lang=js&"
export * from "./editPay.vue?vue&type=script&lang=js&"
import style0 from "./editPay.vue?vue&type=style&index=0&id=8f159b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f159b06",
  null
  
)

export default component.exports